import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { type TimelineFilingRow } from "store/apis/filingsTimeline";

export const useFilingEntityName = (
  filing: TimelineFilingRow | null
): string => {
  const { entities } = useCurrentGroupContext();

  if (!filing || entities.length <= 1) return "";

  return filing.entity_name || "";
};
